/* es5-ext/number/is-nan/index */ function _(require, module, exports) {
    module.exports = require(334) /* ./is-implemented */()
        ? Number.isNaN
        : require(335) /* ./shim */;
}
